import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from "react-router-dom";
import { Fetcher } from '../../../Helpers/fetcher';
import { Notify } from '../../../Helpers/notification';

const CreateSubSuperAdmin = ({ app }) => {
    const apiPath = app.apiPath
    const userId = app.userId
    const history = useHistory();

    const [formData, setFormData] = useState({
        username: '',
        password: '',
        confirmPassword: '',
        name: '',
        emailid: '',
        number: '',
        company: '',
        address: '',
        pincode: '',
        reportType: '',
        accountType: "",
        aclId: "",
        sendDate: new Date(),
        loading: false
    });
    const [aclList, setAclList] = useState([])

    const getAclList = async () => {
        try {
            const res = await Fetcher.get(`${apiPath}/api/obd/acl/setting/list/${userId}`)
            const data = Array.isArray(res) ? res : []
            setAclList(data)
        } catch (error) {
            Notify.notify("Error while getting the module list")
            console.log("getAclList", error)
        }
    }

    const filterTime = (date) => {
        return new Date().getTime() <= date.getTime();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleDateChange = (date) => {
        setFormData(prev => ({
            ...prev,
            sendDate: date
        }));
    };

    const addZero = (i) => (i < 10 ? "0" + i : i);

    const registerUser = (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            Notify.notify("Passwords do not match");
            return;
        }
        if (!formData.aclId) {
            Notify.notify("Select Acl before proceeding");
            return;
        }
        if (!formData.accountType) {
            Notify.notify("Select Account Type");
            return;
        }
        if (!formData.sendDate) {
            Notify.notify("Please select expiry date");
            return;
        }

        const d = formData.sendDate;
        const formattedDate = `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(d.getDate())} 23:59:59`;

        const data = {
            username: formData.username,
            password: formData.password,
            name: formData.name,
            emailid: formData.emailid,
            number: formData.number,
            address: formData.address,
            company: formData.company,
            pincode: formData.pincode,
            parent: userId,
            accountType: Number(formData.accountType),
            userType: "sub_sadmin",
            expiryDate: formattedDate,
            aclId: Number(formData.aclId)
        };

        setFormData(prev => ({ ...prev, loading: true }));

        Fetcher.post(`${apiPath}/api/obd/register`,
            {
                headers: {
                    "Content-type": "application/json",
                },
                method: 'POST',
                body: JSON.stringify(data)
            }
        )
            .then(res => {
                if (res?.message?.toLowerCase().includes("success")) {
                    Notify.notify("User Created Successfully");
                    history.push("/sub-super-admin/user-list");
                    setFormData({
                        username: '',
                        password: '',
                        confirmPassword: '',
                        name: '',
                        emailid: '',
                        number: '',
                        company: '',
                        address: '',
                        pincode: '',
                        reportType: '',
                        accountType: "",
                        aclId: "",
                        sendDate: new Date(),
                        loading: false
                    });
                } else {
                    Notify.notify(res?.message || "Something went wrong");
                    setFormData(prev => ({ ...prev, loading: false }));
                }
            })
            .catch(err => {
                console.error(err);
                Notify.notify("Error creating user");
                setFormData(prev => ({ ...prev, loading: false }));
            });
    };

    useEffect(() => {
        getAclList()
    }, [])
    return (
        <Form onSubmit={registerUser}>
            <Row>
                <Col sm={12}>
                    <Card>
                        <Card.Header>Create New Sub Super Admin</Card.Header>
                        <Card.Body>
                            <Row>
                                <Col sm={4}>
                                    <Form.Control required name="username"
                                        placeholder="Username"
                                        value={formData.username}
                                        onChange={handleChange} />
                                </Col>

                                <Col sm={4}>
                                    <Form.Control required name="password"
                                        type="password"
                                        placeholder="Password"
                                        value={formData.password}
                                        onChange={handleChange} />
                                </Col>

                                <Col sm={4}>
                                    <Form.Control required name="confirmPassword"
                                        type="password"
                                        placeholder="Confirm Password"
                                        value={formData.confirmPassword}
                                        onChange={handleChange} />
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col sm={4}>
                                    <Form.Control required name="name"
                                        placeholder="Name"
                                        value={formData.name}
                                        onChange={handleChange} />
                                </Col>

                                <Col sm={4}>
                                    <Form.Control required name="emailid"
                                        type="email"
                                        placeholder="Email ID"
                                        value={formData.emailid}
                                        onChange={handleChange} />
                                </Col>

                                <Col sm={4}>
                                    <Form.Control required name="number"
                                        placeholder="Mobile Number"
                                        value={formData.number}
                                        onChange={handleChange}
                                        onWheel={(e) => e.target.blur()}
                                    />

                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col sm={4}>
                                    <Form.Control required name="company"
                                        placeholder="Company Name"
                                        value={formData.company}
                                        onChange={handleChange} />
                                </Col>

                                <Col sm={4}>
                                    <Form.Control required name="address"
                                        placeholder="Address"
                                        value={formData.address}
                                        onChange={handleChange} />
                                </Col>

                                <Col sm={4}>
                                    <Form.Control required name="pincode"
                                        placeholder="Pincode"
                                        value={formData.pincode}
                                        onChange={handleChange} />
                                </Col>


                            </Row>
                            <Row className="mt-3">
                                <Col sm={4}>
                                    <Form.Group className="form-group required control-label">
                                        <Form.Select className="dd" required name="accountType" value={formData.accountType} onChange={handleChange} as="select">
                                            <option value="">Select Account Type</option>
                                            <option value="0">Promotional</option>
                                            <option value="1">Transactional</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col sm={4}>
                                    <Form.Label>User Expiry</Form.Label>
                                    <DatePicker
                                        className="form-control"
                                        selected={formData.sendDate}
                                        minDate={new Date()}
                                        dateFormat="yyyy-MM-dd"
                                        onChange={handleDateChange}
                                        filterTime={filterTime}
                                    />
                                </Col>
                                <Col sm={4}>
                                    <Form.Label>Select Acl</Form.Label>
                                    <Form.Select className="dd" required name="aclId" value={formData.aclId} onChange={handleChange} as="select" disabled={!aclList.length} >
                                        <option value="">
                                            {aclList.length ? "Select Acl" : "No ACL Available"}
                                        </option>
                                        {aclList.map(acl => {
                                            return <option key={acl.id} value={acl.id}>{acl?.aclName}</option>
                                        })}
                                    </Form.Select>
                                </Col>
                            </Row>

                            <Button className="mt-3"
                                variant="primary"
                                type="submit"
                                disabled={formData.loading}>
                                {formData.loading ? "Creating..." : "Create User"}
                            </Button>

                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Form>
    );
};

export default CreateSubSuperAdmin;